import axios from "axios";
import Api from "../Api/Api.json";

class VocabService {
  constructor() {
    this.baseURL = Api.SPOKEN_ENGLISH_USER_API;
    this.headers = { "Content-Type": "application/json" };
  }

  async getWordList(index) {
    const requestData = {
      task: "getWordListN",
      index,
    };

    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });

    return response.data;
  }

  async getWordInstructionAudio(wordNumber) {
    const requestData = {
      task: "getInstructionAudio",
      task_type: "word",
      word_number: wordNumber,
    };

    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });

    return response.data;
  }

  async getSentenceInstructionAudio(wordNumber) {
    const requestData = {
      task: "getInstructionAudio",
      task_type: "sentence",
      sentence_number: wordNumber,
    };

    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });

    return response.data;
  }

  async analyzeTranslation (sentence, userResponse) {
    const requestData = {
      task: "analyzeAnswer",
      actual_translation: sentence,
      user_response: userResponse,
    };

    const response = await axios.post(this.baseURL, requestData, {
      headers: this.headers,
    });

    return response.data;
  }
}

export const vocabService = new VocabService();
